import React from 'react';
import { Col , Nav} from "react-bootstrap";

export default function ProjectCard({ title, description, imgUrl, id }) {
  
  const handleCardClick = () => {
  console.log("Click on tab", id);
    // Redirect to a specific URL based on the id
    if (id === "project1") {
      window.location.href = 'https://food-ordering-app-clone.netlify.app/';
    }else if (id === 'youtube') {
      window.location.href = 'https://my-youtube-clone-sh.netlify.app/';
    }else if (id === 'project0') {
      window.location.href = 'https://netflix-clonegpt.web.app/';
    } 
    else if (id === 'project3') {
      window.location.href = 'https://snake-catching-food.netlify.app/';
    } else if (id === 'project4') {
      window.location.href = 'https://calculator-cal.netlify.app/';
    } else if (id === 'project5') {
      window.location.href = 'https://todolistminipro.netlify.app/';
    } else if (id === 'project6') {
      window.location.href = 'https://website-realestate-demo.netlify.app/';
    } else if (id === 'project7') {
      window.location.href = 'https://restaurantmenucardusingreact.netlify.app';
    } else if (id === 'project8') {
      window.location.href = 'https://thebikestore.netlify.app';
    }
    
  }

  return (
    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbx" onClick={handleCardClick}>
        <img src={imgUrl} />
        <div className="proj-txtx">
          <h4>{title}</h4>
          <span>{description}</span>
        </div>
      </div>
    </Col>
  )
}
